module.exports = __webpack_public_path__ + "static/frontUserNew/img/door-nav-scan.c425296c.png";